import React, { Suspense, lazy } from "react";
import { Navigate, Outlet } from "react-router-dom";

const AnalyticsPresence = lazy(() => import("./AnalyticsPresence"));
const PageDurationTracker = lazy(() => import("./PageDurationTracker"));
const AgentWidget = lazy(() => import("./Agent/AgentWidget"));

const PrivateRoute = () => {
  const token = localStorage.getItem("token"); // Fetch stored token

  if (!token) return <Navigate to="/" replace />;

  return (
    <>
      <Suspense fallback={null}>
        <AnalyticsPresence />
        <PageDurationTracker />
      </Suspense>
      <Outlet />
      <Suspense fallback={null}>
        <AgentWidget />
      </Suspense>
    </>
  );
};

export default PrivateRoute;
